import { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Collapse, NavItem, NavLink } from 'shards-react';
import { useLogout } from '../../../../utils/hooks/hooks';
import { connect } from 'react-redux';
import defaultAvatar from '../../../../assets/images/synop_user.png';
import { Link } from 'react-router-dom';

const UserActions = ({ username, avatar, isUserAdmin }) => {
  /**
   * Later we'll take user name from DB!
   * Define default avatar or take it from DB!?!
   */
  const [visible, setVisible] = useState(false);
  const { logout } = useLogout();

  const toggleUserActions = () => setVisible(!visible);

  return (
    <NavItem className='pointer border-left' tag={Dropdown} caret toggle={toggleUserActions}>
      <DropdownToggle caret tag={NavLink} className='text-nowrap px-3'>
        <img className='user-avatar rounded-circle mr-3' src={avatar || defaultAvatar} alt='User Avatar' />
        <span className='d-none d-md-inline-block white-space-pre'>{username}</span>
      </DropdownToggle>
      <Collapse tag={DropdownMenu} right small open={visible}>
        <DropdownItem className='text-secondary' tag={Link} to='/edit-user-profile'>
          <i className='fas fa-user-edit mr-1' />
          Profil bearbeiten
        </DropdownItem>
        {isUserAdmin && (
          <DropdownItem className='text-secondary' tag='a' href='/platform/' target='_blank' rel='noopener noreferrer'>
            <i className='fas fa-file-alt mr-1' />
            Doctypen verwalten
          </DropdownItem>
        )}
        <DropdownItem data-cy="logout" className='text-secondary' onClick={logout}>
          <i className='fas fa-sign-out-alt mr-1' />
          Logout
        </DropdownItem>
      </Collapse>
    </NavItem>
  );
};

const mapStateToProps = ({ userData: { fullName, avatar, isUserAdmin } }) => {
  /**
   * Take the username saved in redux and return it
   * in components props.
   */
  return {
    avatar,
    username: fullName,
    isUserAdmin,
  };
};
export default connect(mapStateToProps)(UserActions); //Export component and connect it with redux.
